import React, { useRef, useEffect } from 'react'
import { useWithReactFunctionalTrack } from '@du/analytics-sdk'
import { createTrackConfig } from '../../trackConfig'
import styles from '../../index.less'
import { TabItemType } from '../../types'

function CustomTabItem(props: {
  data: TabItemType
  snapUpStatus: {
    [key: string]: string
  }
}) {
  const { data, snapUpStatus } = props
  let intersectionObserver: IntersectionObserver | null = null

  // 添加埋点
  const functionalPropsRef: React.MutableRefObject<{ $track?: any }> = useRef({})
  const functionalRef = useRef(null)

  useWithReactFunctionalTrack({
    functionalRef,
    functionalProps: functionalPropsRef.current,
    useEffect,
    createTrackConfig,
  })

  const trackHelper = (name, info = {}) => {
    functionalPropsRef.current.$track && functionalPropsRef.current.$track(name, info)
  }

  useEffect(() => {
    ObserveImage()
  }, [])

  function ObserveImage() {
    intersectionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((item) => {
          if (item.intersectionRatio >= 0.5) {
            // console.log('.......', item)
            // 。。。 埋点曝光代码
            trackHelper('poizon_common_exposure', {
              current_page: 82,
              block_type: 3026,
              level_1_tab_title: data.venueId,
            })
            intersectionObserver.unobserve(item.target)
          }
        })
      },
      {
        root: null,
        threshold: [0.5], // 阀值设为1，当只有比例达到0.5时才触发回调函数
      }
    )

    // 监视
    const currentVenueFlag = functionalRef.current
    currentVenueFlag && intersectionObserver.observe(currentVenueFlag)
  }

  return (
    <div className={styles['custom-tab-item']} ref={functionalRef}>
      <div className={styles['time-str-wrapper']}>
        {/* <span className={styles['time-str-wrapper']}>{data.title}</span> */}
        <span className={styles['time-str']}>{data.title}</span>
        {data.date && <span className={styles['date-str-wrapper']}>{data.date}</span>}
      </div>
      <div className={styles['status-map-to-word']}>{snapUpStatus[data.status]}</div>
    </div>
  )
}

export default CustomTabItem
